import { CategoryQuery as SourceCategoryQuery } from 'SourceQuery/Category.query';

export class CategoryQuery extends SourceCategoryQuery{

    _getDefaultFields() {
        return [
            'id',
            'url',
            'name',
            'image',
            'url_key',
            'url_path',
            'is_active',
            'meta_title',
            'description',
            'canonical_url',
            'product_count',
            'meta_keywords',
            'default_sort_by',
            'meta_description',
            'landing_page',
            'display_mode',
            'is_anchor',
            'category_page_cms_block_left',
            'category_page_cms_block_listing',
            this._getCmsBlockField(),
            this._getBreadcrumbsField()
        ];
    }
}

export default new CategoryQuery();
